<div class="sideNav-driverListContainer" [ngClass]="{'is-mobile-view': isMobileView}">
  @for (driver of drivers; track driver.driverId) {
  <div class="sideNav-driverContainer" >
    <div class="sideNav-driverCardTopPart">
      <div class="sideNav-driverListTopPart_part">
        <mat-icon class="driverIcon">{{ driver.motivationIconName }}</mat-icon>
        <span class="driverNameText">{{ driver.motivationName }}</span> 
      </div>
      <div class="sideNav-driverListTopPart_part">
        <div class="sideNav-tag-tooltip-container">
          <!-- <app-culture-impact-tag
            [impact]="driver.impact"
            style="margin: 0 8px"
          ></app-culture-impact-tag> -->
          <span class="sideNav-driverList-impact">({{driver.count}}/{{driver.totalUsers}})</span>
          <app-claro-tooltip-icon
            [translatedTooltipText]="'stateView.tooltipTexts.driverImpact' | translate">
          </app-claro-tooltip-icon>      
      </div>
      </div>
    </div>
    <mat-divider style="width: 90%; margin: 0 auto"></mat-divider>
    <div class="sideNav-driverCardBottomPart">
      <app-claro-progress-bar
        style="width: 65%"
        [value]="driver.score"
        [height]="'5px'"
        [fillColor]="driver.progressBarColorString ?? ''"
      ></app-claro-progress-bar>
      <div class="sideNav-percentText-tooltip-container">
        <span class="driverPercentText">{{ driver.score }}%</span>
        <app-claro-tooltip-icon
          [translatedTooltipText]="'stateView.tooltipTexts.driverScore' | translate"
        ></app-claro-tooltip-icon>
      </div>
    </div>
  </div>
  }
</div>
